module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Schedule/images/background.ad967184.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Schedule/images/background.png
// module id = 2523
// module chunks = 11